<template>
  <layout-default :hide-footer-mobile="true">
    <link
      rel="stylesheet"
      href="https://use.fontawesome.com/releases/v5.7.0/css/all.css"
      integrity="sha384-lZN37f5QGtY3VHgisS14W3ExzMWZxybE1SJSEsQp9S+oqd12jhcu+A56Ebc1zFSJ"
      crossorigin="anonymous"
    />

    <div class="container-fluid header-outlet">
      <div class="row">
        <div class="col-md-12">
          <h1 class="banner-home-title">
            <u>Venta de paquetes con descuento</u>
          </h1>
          <h2 class="banner-home-title2">Últimos cupos</h2>
          <p class="banner-home-title3">Clases iniciadas el 07 de Abril 2025</p>
        </div>
      </div>
    </div>

    <section class="porque-pdv-section">
      <div class="container">
        <h1 class="section-title">
          <u>¿Por qué prepararte en Preu Pedro de Valdivia?</u>
        </h1>

        <div class="cards-wrapper">
          <div class="razon-card">Líderes en Puntajes Máximos Nacionales</div>
          <div class="razon-card">Programas Personalizados</div>
          <div class="razon-card">Variedad de precios</div>
          <div class="razon-card">Excelencia Académica</div>
        </div>

        <div class="ver-mas-wrapper">
          <a
            href="https://www.preupdv.cl/modelo-educativo-360"
            class="btn-ver-mas"
            >Ver más</a
          >
        </div>
      </div>
    </section>

    <div class="select-container mt-5">
      <h3 class="mb-3">Antes de comenzar, selecciona tu sede:</h3>
      <div class="select-actions">
        <multiselect
          v-model="selectedLocation"
          :options="sortedLocationList"
          placeholder="Seleccionar sede"
          label="location"
          name="location"
          :showLabels="false"
          class="select-outlet"
        />
        <button @click="filterPacks" class="btn-outlet-filtro">Filtrar</button>
      </div>
    </div>

    <div class="d-block d-md-none px-3">
      <carousel
        :per-page="1"
        :navigation-enabled="true"
        :pagination-enabled="true"
        :scroll-per-page="true"
        :loop="true"
        :autoplay="true"
        :autoplay-timeout="5000"
        :navigationClickTargetSize="0"
        :spacePadding="0"
        :centerMode="true"
      >
        <slide v-for="pack in paginatedPacks" :key="pack.id">
          <div class="card-program">
            <div class="header-card">
              <h4 class="title-pack">{{ pack.title }}</h4>
              <a class="sede-pack">
                <strong>{{ formatLocationName(pack.Location.name) }}</strong>
              </a>
            </div>
            <div class="asignatura-bg">
              <h5 class="asignatura">Asignaturas</h5>
            </div>
            <div class="materias-packs">
              <div v-for="detail in pack.PackDetails" :key="detail.courseId">
                <h6 class="materia-detalle mb-0">
                  <img
                    :src="getIcon(pack.modalidad)"
                    class="icon-btn"
                    alt="streaming"
                  />
                  {{ cleanCourseName(detail.Course.name) }}
                </h6>
                <p class="horarios">
                  <template v-for="(schedule, j) in detail.Course.Schedules">
                    {{ schedule.dayOfWeek.substr(0, 3) }}
                    {{ schedule.startTime.replaceAll(":00", "") }} a
                    {{ schedule.endTime.replaceAll(":00", "") }} hs
                    <span v-if="j < detail.Course.Schedules.length - 1" :key="j"
                      >y</span
                    >
                  </template>
                </p>
              </div>
            </div>
            <div class="checkout-card">
              <div class="precio-pack">
                <a class="precio-old">{{ pack.price | moneyFormatter }}</a>
                <h5 class="precio-final">
                  {{ pack.priceOfert | moneyFormatter }}
                </h5>
                <a class="availability">{{ pack.stock }} lugares disponibles</a>
              </div>
              <div class="btn-comprar">
                <button class="btn-pack" @click="gotoSteep2(pack)">
                  Comprar ahora
                </button>
              </div>
            </div>
          </div>
        </slide>
      </carousel>
    </div>

    <div class="container pt-5 d-none d-md-block">
      <div class="row">
        <div
          class="col-12 col-sm-6 col-md-4 col-lg-4 mb-3"
          v-for="pack in paginatedPacks"
          :key="pack.id"
        >
          <div class="card-program">
            <div class="header-card">
              <h4 class="title-pack">{{ pack.title }}</h4>
              <a class="sede-pack">
                <strong>{{ formatLocationName(pack.Location.name) }}</strong>
              </a>
            </div>

            <div class="asignatura-bg">
              <h5 class="asignatura">Asignaturas</h5>
            </div>
            <div class="materias-packs">
              <div v-for="detail in pack.PackDetails" :key="detail.courseId">
                <h6 class="materia-detalle mb-0">
                  <img
                    :src="getIcon(pack.modalidad)"
                    class="icon-btn"
                    alt="streaming"
                  />
                  {{ cleanCourseName(detail.Course.name) }}
                </h6>

                <p class="horarios">
                  <template v-for="(schedule, j) in detail.Course.Schedules">
                    {{ schedule.dayOfWeek.substr(0, 3) }}
                    {{ schedule.startTime.replaceAll(":00", "") }} a
                    {{ schedule.endTime.replaceAll(":00", "") }} hs
                    <span
                      v-if="j < detail.Course.Schedules.length - 1"
                      :key="j"
                    >
                      y
                    </span>
                  </template>
                </p>
              </div>
            </div>
            <div class="checkout-card">
              <div class="precio-pack">
                <a class="precio-old">
                  {{ pack.price | moneyFormatter }}
                </a>
                <h5 class="precio-final">
                  {{ pack.priceOfert | moneyFormatter }}
                </h5>
                <a class="availability">
                  {{ pack.stock }} lugares disponibles
                </a>
              </div>
              <div class="btn-comprar">
                <button class="btn-pack" @click="gotoSteep2(pack)">
                  Comprar ahora
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pagination justify-content-center">
        <button
          v-for="page in totalPagesArray"
          :key="page"
          @click="changePage(page)"
          :class="{ active: page === currentPage }"
        >
          {{ page }}
        </button>
      </div>
    </div>

    <a
      href="https://ventaonline.preupdv.cl/"
      class="recuadro"
      style="text-decoration: none"
    >
      <h2
        style="
          color: white;
          font-size: 24px;
          font-family: 'Poppins', sans-serif;
          font-weight: 400 !important;
          line-height: 1.4;
        "
      >
        Revisa nuestra oferta completa y matricula con hasta un 
        <span
          style="
            font-weight: 600;
            font-size: 1.1em;
            font-family: 'Arial Black', 'Arial Bold', Gadget, sans-serif;
          "
          >45%</span
        >
        <br/> de descuento.
      </h2>
      <img src="/images/featured/icono-verde.svg" alt="Flecha" class="flecha" />
    </a>

    <div class="info-recomendador1">
      <img
        src="/images/featured/tri-sup-izq-gris-mobile.svg"
        class="only-mobile w-full"
        alt="tri-sup-izq-gris-mobile"
      />
      <img
        src="/images/featured/tri-sup-izq-gris-desktop.svg"
        class="only-desktop w-full"
        alt="tri-sup-izq-gris-desktop"
      />
      <div class="fondo">
        <div class="pdv-container">
          <div class="perent-columns">
            <div class="column-info">
              <h2 class="titulo">
                Si necesitas ayuda para personalizar tu programa puedes
                comunicarte con nuestros asesores
              </h2>
              <div class="links"></div>
              <div class="botones only-desktop">
                <a
                  href="tel:6005002020"
                  class="boton-new-primario boton-new-mediano"
                >
                  <img
                    src="/images/featured/call-icon.svg"
                    class=""
                    alt="callicon"
                  />
                  600 500 2020
                </a>
                <Button
                  title="Preguntas frecuentes"
                  type="terciario"
                  size="medium"
                />
                <a
                  href="https://preupdv.cl/admision/"
                  target="_blank"
                  class="boton-new-terciario boton-new-mediano"
                >
                  Formulario de contacto
                </a>
              </div>
            </div>
            <div class="column-ilustracion">
              <img
                src="/images/featured/boy-computer-list-cap-design-verde.svg"
                class="w-full"
                alt="boy-computer-list-cap-design-verde"
              />
            </div>
            <div class="only-mobile column-info">
              <h3 class="texto">
                ¿Tienes dudas sobre nuestros programas? Hablemos
              </h3>
              <div class="botones">
                <router-link
                  :to="{ name: 'Landing' }"
                  class="boton-new-primario boton-new-mediano"
                >
                  <img
                    src="/images/featured/call-icon.svg"
                    class=""
                    alt="callicon"
                  />
                  +56 2 2994 9850
                </router-link>
                <Button
                  title="Preguntas frecuentes"
                  type="terciario"
                  size="medium"
                  :fullWidth="true"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout-default>
</template>

<script>
import LayoutDefault from "@/layouts/Default";
import Multiselect from "vue-multiselect";
import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { Carousel, Slide } from "vue-carousel";

Vue.use(VueSweetalert2);

global.jQuery = require("jquery");
const $ = global.jQuery;
window.$ = $;

export default {
  data() {
    return {
      packs: [],
      filteredPacks: [],
      locations: [],
      locationsList: [],
      selectedLocation: null,
      onlineSalesLink: "https://ventaonline.preupdv.cl",
      currentPage: 1,
      itemsPerPage: 15,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.filteredPacks.length / this.itemsPerPage);
    },
    paginatedPacks() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return this.filteredPacks.slice(startIndex, endIndex);
    },

    sortedLocationList() {
      this.locationsList.forEach((loc) => console.log(`[${loc.location}]`));

      return this.locationsList
        .map((loc) => {
          let nombre = loc.location.trim();

          // Reemplazamos "Norte " solo en los casos específicos
          if (nombre === "Norte Calama") nombre = "Calama";
          if (nombre === "Norte La Serena") nombre = "La Serena";
          if (nombre === "Norte Antofagasta") nombre = "Antofagasta";

          return { ...loc, location: nombre }; // Retornamos el objeto con el nombre modificado
        })
        .filter((loc) => loc.location.toLowerCase() !== "pdv online") // Eliminamos PDV Online
        .sort((a, b) => a.location.localeCompare(b.location));
    },

    totalPagesArray() {
      return Array.from({ length: this.totalPages }, (_, i) => i + 1);
    },
  },

  components: {
    LayoutDefault,
    Multiselect,
    Carousel,
    Slide,
  },
  mounted() {
    this.getLocations();
    this.getPacks();

    const zoomScript = document.createElement("script");
    zoomScript.src = "https://us01ccistatic.zoom.us/us01cci/web-sdk/zcc-sdk.js";
    zoomScript.setAttribute("data-apikey", "G4nAX1GiTf6ib-GJAcV4Qw");
    zoomScript.setAttribute("data-env", "us01");
    zoomScript.async = true;
    document.body.appendChild(zoomScript);
  },

  beforeDestroy() {
    const script = document.querySelector(
      'script[src="https://us01ccistatic.zoom.us/us01cci/web-sdk/zcc-sdk.js"]'
    );
    if (script) {
      script.remove(); // Elimina el script al salir de la página
    }
  },

  methods: {
    async getLocations() {
      try {
        const { data } = await this.Axios.get("/locations?pdvX=true");
        const formatedData = data.map((element) => ({
          ...element,
          name: element.name
            .replace(/^Preuniversitario\s*/, "")
            .replace(/^Pre\s*/, ""),
        }));
        this.locationsList = formatedData.map((loc) => ({
          location: loc.name,
          id: loc.id,
        }));
      } catch (error) {
        this.$swal({
          title: "Error",
          text: "Ha ocurrido un error al cargar las sedes",
          icon: "error",
        });
      }
    },
    formatLocationName(name) {
      return name
        .replace(/^Preuniversitario\s*/, "Sede ")
        .replace(/^Pre\s*/, "Sede ");
    },

    cleanCourseName(name) {
      let newName = name
        .replace(/\s\d{3}$/, "") // Elimina códigos de 3 dígitos al final
        .replace(/\b(Tercero|Tarde|Egresado)\b/g, "") // Elimina palabras específicas
        .trim(); // Limpia espacios extra

      // Reemplazos específicos
      if (newName === "Lenguaje") return "Competencia Lectora";
      if (newName === "Matemática") return "Competencia Matemática M1";
      if (newName === "Matemática Electivo") return "Competencia Matemática M2";

      return newName;
    },

    async getPacks() {
      try {
        const { data } = await this.Axios.get("/dashadmin/activepacks");
        this.packs = data;
        this.filteredPacks = data;
      } catch (error) {
        this.$swal({
          title: "Error",
          text: "Ha ocurrido un error al cargar los paquetes",
          icon: "error",
        });
      }
    },
    getUniqueLocations() {
      const uniqueLocations = [];
      this.packs.forEach((pack) => {
        pack.PackDetails.forEach((detail) => {
          const locationName = detail.Location.name;
          if (!uniqueLocations.includes(locationName)) {
            uniqueLocations.push(locationName);
          }
        });
      });
      return uniqueLocations;
    },

    getIcon(modalidad) {
      switch (modalidad) {
        case "Presencial":
          return "/images/featured/frame.svg";
        case "Streaming":
          return "/images/featured/monitor-recorder.svg";
        default:
          return "/images/featured/online.svg";
      }
    },
    getLocation(pack) {
      if (pack.PackDetails.length > 0) {
        let value = "";
        pack.PackDetails.forEach((detail) => {
          if (value != detail.Location.name) {
            this.locationList.push(detail.Location.name);
          }
          value = detail.Location.name;
        });
      }
    },
    async gotoSteep2(pack) {
      this.$router.push({ name: "Outlet2", query: { packId: pack.id } });
    },

    data() {
      return {
        packs: [],
        locationsList: [],
        selectedLocation: "",
      };
    },

    filterPacks() {
      if (!this.selectedLocation) {
        this.filteredPacks = this.packs;
      } else {
        this.filteredPacks = this.packs.filter((pack) => {
          return pack.PackDetails.some(
            (detail) => detail.locationId === this.selectedLocation.id
          );
        });
      }
      this.currentPage = 1;
    },

    changePage(page) {
      this.currentPage = page;
    },
    onLocationSelected({ id }) {
      this.selectedLocation = id;
    },
  },
};
</script>

<style lang="scss" scoped>
.d-block.d-md-none {
  position: relative;
  padding: 0 40px;
}

.banner-descuento-wrapper {
  position: relative;
  width: 100%;
}

.carousel {
  width: 100%;
  position: relative;
}

.VueCarousel-wrapper {
  overflow: visible !important;
  padding: 0 20px;
}

.VueCarousel-slide {
  display: flex;
  justify-content: center;
}

.VueCarousel-navigation-button {
  position: absolute !important;
  background-color: rgba(0, 0, 0, 0.5) !important;
  border-radius: 50%;
  width: 50px !important;
  height: 50px !important;
  top: 50% !important;
  transform: translateY(-50%);
  z-index: 10;
  color: white !important;
  font-size: 24px !important;
  padding: 0 !important;
  margin: 0 !important;
  cursor: pointer;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.VueCarousel-navigation-button.VueCarousel-navigation-prev {
  left: 0 !important;
}

.VueCarousel-navigation-button.VueCarousel-navigation-next {
  right: 0 !important;
}

.VueCarousel-navigation-button::before {
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  font-size: 24px;
  color: white;
}

.VueCarousel-navigation-button.VueCarousel-navigation-prev::before {
  content: "\f104";
}

.VueCarousel-navigation-button.VueCarousel-navigation-next::before {
  content: "\f105";
}

.header-outlet {
  background-image: url("/images/svgs/background-hero.svg");
  background-color: #ffd200;
  background-size: cover;
  padding: 40px;
  @media (max-width: 768px) {
    margin: -10px;
  }
  @media (min-width: 769px) {
  }
}

.select-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin: 0 auto;
  max-width: fit-content;
}

.banner-home-title {
  margin-bottom: 0;
  color: $colorTerciario;
  font-family: "Poppins-ExtraBold", sans-serif;
  z-index: 10;

  @media (max-width: 768px) {
    margin: 24px 0 24px 0;
    font-size: 30px;
    line-height: 28px;
    text-align: center;
  }
  @media (min-width: 769px) {
    margin-top: 12px;
    font-size: 48px;
    line-height: 58px;
    text-align: center;
  }
}
.banner-home-title2 {
  margin-bottom: 0;
  margin-top: 12px;
  color: $colorTerciario;
  font-family: "Poppins-Medium", sans-serif;
  font-size: 36px !important;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 35px;
  }
  @media (min-width: 769px) {
    margin-top: 17px;
    font-size: 20px;
    line-height: 35px;
  }
}

.banner-home-title3 {
  margin-bottom: 0;
  margin-top: 17px;
  color: $colorTerciario;
  font-family: "Poppins-Medium", sans-serif;
  font-size: 20px !important;
  text-align: center;
}

.img-header {
  width: 456px;

  @media (max-width: 768px) {
    width: 312px;
    height: 202px;
  }
}

.recuadro {
  position: relative;
  display: block;
  background-color: #166534;
  color: white !important;
  font-weight: 700;
  font-size: 25px;
  text-align: center;
  margin: 2rem auto;
  width: 80vw;              
  max-width: 800px;        
  padding: 25px 20px;
  box-sizing: border-box;
}

.recuadro h2 {
  color: white;
  font-size: 22px;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  line-height: 1.4;
  margin: 0;
  padding: 0 10px;
}

.recuadro h2 span {
  font-weight: 600;
  font-size: 1.4em;
  font-family: 'Arial Black', 'Arial Bold', Gadget, sans-serif;
}

/* Responsivo */
@media (min-width: 768px) {
  .recuadro {
    font-size: 2.25rem;
    padding: 25px 20px;
    min-width: 400px;
    max-width: 800px;
  }
  
  .recuadro h2 {
    font-size: 24px;
  }
}

@media (max-width: 767px) {
  .recuadro {
    padding: 20px 15px;
    width: 80vw;
  }
  
  .recuadro h2 {
    font-size: 20px;
  }
}

.flecha {
  position: absolute;
  right: -21px;
  bottom: -18px;
}


.select-filtro {
  width: 250px;
  height: 38px;
  border: 2px solid lightgray;
  border-radius: 30px 30px 30px 30px;
}
.select-outlet {
  min-width: 240px;
  max-width: 300px;
}

.btn-outlet-filtro {
  height: 42px;
  padding: 0 24px;
  background-color: #592466;
  color: white;
  border: 2px solid #592466;
  border-radius: 30px;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
  white-space: nowrap;
}

.seleccion-sede {
  font-size: 12px;
  color: #8a8c93;
  margin-left: 18px;
}
.banner-descuento img {
  width: 100%;
  height: auto;
  display: block;
}

.info-recomendador1 {
  .fondo {
    background-color: $neutral05;
  }

  .perent-columns {
    display: flex;
    @media (max-width: 768px) {
      flex-direction: column;
      padding: 48px 24px;
    }
    @media (min-width: 769px) {
      flex-direction: row;
      padding: 40px 76px 64px 76px;
      gap: 50px;
    }

    .column-info {
      display: flex;
      flex-direction: column;
      @media (max-width: 768px) {
        width: 100%;
      }
      @media (min-width: 769px) {
        width: 622px;
      }

      .titulo {
        color: $neutralBlack;
        @media (max-width: 768px) {
          font-family: "Poppins-Bold", sans-serif;
          font-size: 27px;
          line-height: 37px;
          margin-bottom: 32px;
        }
        @media (min-width: 769px) {
          font-family: "Poppins-Bold", sans-serif;
          font-size: 40px;
          line-height: 50px;
          margin-bottom: 24px;
        }
      }
      .links {
        display: flex;
        flex-direction: column;
        @media (min-width: 769px) {
          margin-bottom: 40px;
        }

        .links-items {
          display: flex;
          justify-content: space-between;
          padding: 16px 0;

          @media (max-width: 768px) {
            width: 100%;
          }
          @media (min-width: 769px) {
            width: 400px;
          }

          .links-items-text {
            img {
              margin-right: 12px;
            }
            span {
              color: $neutralBlack;
              font-family: "Poppins-Medium", sans-serif;
              font-size: 16px;
              line-height: 24px;
            }
          }
        }
      }
      .texto {
        color: $neutralBlack;
        @media (max-width: 768px) {
          font-family: "Poppins-Bold", sans-serif;
          font-size: 27px;
          line-height: 37px;
          margin-bottom: 32px;
        }
        @media (min-width: 769px) {
          font-family: "Poppins-Bold", sans-serif;
          font-size: 20px;
          line-height: 28px;
          margin-bottom: 24px;
        }
      }
      .botones {
        display: flex;
        flex-wrap: wrap;

        @media (max-width: 768px) {
          flex-direction: column;
          gap: 16px;
        }
        @media (min-width: 769px) {
          flex-direction: row;
          gap: 16px;
        }
      }
    }
    .column-ilustracion {
      @media (max-width: 768px) {
        width: 100%;
        margin: 48px 0 36px 0;
      }
      @media (min-width: 769px) {
        flex: 1;
      }
    }
  }
}

.container {
  padding: 0 15px;

  @media (max-width: 768px) {
    padding: 0 12px;
  }
}

.select-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 600px;
  margin: 3rem auto;
  text-align: center;

  .select-actions {
    display: flex;
    gap: 16px;
    width: 100%;
    justify-content: center;
    align-items: center;

    .select-outlet {
      width: 100%;
      max-width: 400px;
      border: 2px solid #000000;
      border-radius: 6px;
    }

    .btn-outlet-filtro {
      white-space: nowrap;
    }
  }
}

.card-program {
  flex-direction: column;
  justify-content: space-between;
  height: 500px;
  padding: 10px;
  display: flex;
  border: solid 2px $colorTerciario;
  border-radius: 8px 24px 8px 8px;
  margin-bottom: 20px;
  margin: 0 auto;

  @media (max-width: 768px) {
    width: 83%;
    flex-direction: column;
    align-items: center;
  }
  @media (min-width: 769px) {
    flex-direction: column;
    padding: 10px;
  }
  .header-card {
    min-height: 100px;
    padding: 1rem;
    display: flex;
    flex-direction: column;

    @media (max-width: 768px) {
      align-items: center;
      text-align: center;
    }
    @media (min-width: 769px) {
      align-items: flex-start;
      text-align: left;
    }
  }

  .title-pack {
    font-size: 18px;
    color: #1b1b1d;
    font-family: "Poppins-Bold";
    margin: 0 0 8px 0;

    @media (min-width: 769px) {
      font-size: 20px;
    }
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }

  .asignatura-bg {
    padding: 16px, 24px, 16px, 24px;
    background-color: #3b3c3f;
    background-size: cover;
    gap: 10px;
    margin: 0px -10px 0px -10px;

    @media (max-width: 768px) {
      width: 109%;
    }
  }

  .asignatura {
    padding: 12px;
    color: #ffffff;
    font-family: "Poppins-Medium", sans-serif;
    font-size: 16px;
    line-height: 24px;
    padding-left: 20px;

    @media (max-width: 768px) {
      width: 312px;
      height: 56px;
    }
  }

  .materias-packs {
    flex-grow: 1;
    overflow-y: auto;
    background-color: #f7eafa;
    border-left: solid 6px #592466;

    @media (max-width: 768px) {
      padding: 15px 10px 30px 10px;
      height: 450px;
      width: 108%;
      max-height: 280px;
    }
    @media (min-width: 769px) {
      padding: 15px 10px 80px 10px;
      margin: 0px -10px 0px -10px;
      height: 400px;
    }
    @media (max-width: 576px) {
      max-height: 250px;
    }

    @media (min-width: 577px) and (max-width: 768px) {
      max-height: 300px;
    }

    @media (min-width: 769px) {
      max-height: 280px;
    }
  }

  .horarios {
    color: rgb(30, 30, 30);
  }

  .checkout-card {
    display: flex;
  }
  .precio-old {
    text-decoration: line-through;
    font-size: 10px;
    color: #8a8c93;
  }
  .precio-final {
    font-weight: bolder;
    color: black;
  }
  .availability {
    font-size: 12px;
  }
  .btn-comprar {
    padding-top: 18px;
    padding-left: 30px;

    @media (min-width: 769px) {
      text-align: right;
    }

    .btn-pack {
      background-color: white;
      color: black;
      padding: 10px;
      border-radius: 100px;
      border: 2px solid black;
      font-size: 15px;
      display: inline-block;
      width: 100%;
      max-width: 100%;
      gap: 8px;
      margin: auto;
      @media (max-width: 768px) {
        width: 100%;
        margin: 0 auto;
        max-width: 220px;
        margin-left: 0px;
      }
      @media (min-width: 769px) {
        margin: 0 auto;
      }
    }
  }
}

.page-nro {
  border: 1px solid grey;
  border-radius: 8px;
  padding: 8px;
}
.pagination {
  margin-top: 20px;
}

.pagination button {
  background-color: white;
  color: black;
  border: 2px solid grey;
  border-radius: 4px;
  padding: 5px 10px;
  margin-right: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.pagination button:hover {
  background-color: grey;
}

.pagination button.active {
  background-color: #f7eafa;
  font-weight: bold;
}

.pagination button:disabled {
  background-color: #e9ecef;
  color: #6c757d;
  cursor: not-allowed;
}

.page-nro {
  margin: 0 15px;
  font-size: 16px;
  font-weight: bold;
}

.select-outlet {
  flex: 1;
  min-width: 220px;

  .multiselect {
    .multiselect__tags {
      font-size: 16px;
      line-height: 18px;
      font-family: "ubunturegular", Arial, sans-serif;
      background: transparent !important;
      height: 52.38px;
      border-radius: 100px;
      border: 2px solid #000000 !important;
      display: flex;
      align-items: center;
      padding: 0 24px;
    }
    .multiselect__option--selected {
      background: $neutral05;
    }
  }
}
.sede-pack {
  color: #333;
  font-family: "Poppins-Medium";
  font-size: 14px;

  @media (max-width: 768px) {
    font-size: 13px;
  }

  @media (min-width: 769px) {
    font-size: 15px;
  }
}

.porque-pdv-section {
  padding: 3rem 1rem;
  background-color: #fff;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;
  }

  .section-title {
    font-size: 2.25rem;
    font-weight: 800;
    color: #1b1b1d;
    font-family: "Poppins-Bold", sans-serif;
    margin-bottom: 2rem;

    span {
      background: linear-gradient(to top, #ffb347 40%, transparent 40%);
      display: inline-block;
      padding: 0 8px;
    }

    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
  }

  .cards-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
    margin-bottom: 2rem;

    .razon-card {
      background-color: #f1f1f2;
      border: 2px solid #000;
      border-radius: 10px 40px 10px 10px;
      padding: 1rem 1.5rem;
      font-weight: 600;
      font-family: "Poppins-Medium", sans-serif;
      max-width: 260px;
      width: 100%;
      text-align: center;
    }
  }

  .ver-mas-wrapper {
    margin-top: 1rem;

    .btn-ver-mas {
      border: 2px solid #000;
      border-radius: 100px;
      padding: 0.5rem 1.5rem;
      background-color: transparent;
      font-size: 1rem;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s ease;
      color: black;

      &:hover {
        background-color: #000;
        color: #fff;
      }
    }
  }
}

.poppins-regular {
  font-family: "Poppins", sans-serif !important;
  font-weight: 400 !important;
  font-style: normal !important;
}

.poppins-bold {
  font-family: "Poppins", sans-serif !important;
  font-weight: 700 !important;
  font-style: normal !important;
}
</style>

<style scoped lang="scss">
.page-not-found {
  text-align: center;
  padding-top: 50px;
  height: 80vh;
  .main-content {
    position: relative;
    top: 50%;
    transform: translateY(-50%);

    img {
      width: 300px;
      @include media-breakpoint-down(sm) {
        width: 80%;
      }
    }
    h3 {
      font-size: 38px;
      @include alternative-medium-regular;
      margin-bottom: 10px;

      @include media-breakpoint-down(sm) {
        font-size: 24px;
        line-height: 28px;
      }
    }
    p {
      font-size: 20px;
      line-height: 24px;
      @include alternative-light-regular;
      margin-bottom: 24px;

      @include media-breakpoint-down(sm) {
        line-height: 22px;
        font-size: 18px;
      }
    }
  }
}
</style>
